import style from './timeline.module.css'
import { formatSeconds } from '../globals';
import { useEffect, useState } from 'react';
import { adjDim } from '../myhooks/custom-hooks';


function AppTimeline(props) {
    const TIMELINE_LEFT = 16;
    const TIMELINE_WIDTH = 341;
    const MIN_UTTERANCE_WIDTH = 1;
    const [_transcripts, setTranscripts] = useState(props.transcripts)
    const [displayTranscripts, setDisplayTranscripts] = useState([]);
    const [previousTranscriptCount, setPreviousTranscriptCount] = useState(0);
    const [startText, setStartText] = useState('Start');
    const [endText, setEndText] = useState('Now');
    const [_start, setStart] = useState();
    const [_end, setEnd] = useState();
    //const [reload, setReload] = useState(false);

    useEffect(() => {
        if (props.transcripts !== undefined) {
            setTranscripts(props.transcripts);
        }

        if (props.start !== undefined) {
            setStart(props.start);
            if (props.start === 0) {
                setStartText('Start');
            } else {
                setStartText(formatSeconds(props.start)); // Use props.start directly, not stale _start
            }
        }

        if (props.end !== undefined) {
            setEnd(props.end);
            if (props.end === props.session?.length) {
                setEndText((props.session?.recording) ? 'Now' : 'End');
            } else {
                setEndText(formatSeconds(props.end)); // Use props.end directly, not stale _end
            }
        }
    }, [props.transcripts, props.start, props.end, props.session?.length, props.session?.recording])

    // Separate effect for refreshing timeline when dependencies change
    useEffect(() => {
        refreshTimeline();
    }, [props.transcripts, props.start, props.end])


    const refreshTimeline = () => {
        // Use props directly to avoid stale state issues
        const start = props.start ?? 0;
        const end = props.end ?? 0;
        const duration = end - start;

        const temptranscript = [];
        if (props.transcripts !== undefined && duration > 0) {
            for (const transcript of props.transcripts) {
                const pct_start = (transcript.start_time - start) / duration;
                const pct_length = transcript.length / duration;
                const displayTranscript = {};
                displayTranscript['transcript'] = transcript;
                displayTranscript['left'] = adjDim(pct_start * TIMELINE_WIDTH + TIMELINE_LEFT);
                displayTranscript['width'] = adjDim(Math.min(Math.max(pct_length * TIMELINE_WIDTH,
                    MIN_UTTERANCE_WIDTH), TIMELINE_WIDTH * (1 - pct_start)));
                temptranscript.push(displayTranscript);
            }
        }
        setDisplayTranscripts(temptranscript);
    }

    const openTranscriptDialog = (transcript) => {
        props.clickedTimeline(transcript);
    }
   

    return (
        <div className="small-section">
            <div className={style.legend}>
                <span className={`${style["color-box"]} ${style.question}`}></span>
                <span className={style["legend-text"]}>Question</span>
                <span className={`${style["color-box"]} ${style.discussion}`}></span>
                <span className={style["legend-text"]}>Discussion</span>
                <span className={`${style["color-box"]} ${style.silence}`}></span>
                <span className={style["legend-text"]}>Silence</span>
            </div>
            <div className={style.line}></div>
            <div className={style.timeline}>
                {
                    displayTranscripts.map((transcript, index) => (
                        <span key={index}>
                            <span
                                className={transcript.transcript.question ? `${style["utterance"]} ${style["question"]}` : style["utterance"]}
                                onClick={() => openTranscriptDialog(transcript.transcript)}
                                style={{ left: `${transcript.left}` + 'px', width: `${transcript.width}` + 'px' }}>
                            </span>
                        </span>
                    ))
                }

            </div>
            <div className={style["time-textbox"]}>
                <div className={style["time-text"]}>{startText}</div>
                <div className={style["time-text"]}>{endText}</div>
            </div>
        </div>
    )
}

export {AppTimeline}
